import _ from 'lodash';
import { checkFakeSubscription } from '../../helper';

export const getSelectedValue = (providers, value) => {
  if (_.isNull(value) || _.isUndefined(value)) {
    return value;
  }

  const findProvider = providers.find((type) => Number(type.id) === Number(value));
  if (findProvider) {
    return {
      label: findProvider.name,
      value: findProvider.id,
    }
  }
  return null;
};

/**
 * @name getSelectedOptions
 * @param {array} providers
 * @param {object|null} modal
 * @description
 *
 * Если модалка fake_subscription, то
 * Показываем провайдеры только с subscriptions = true
 * (Это только наши провайдеры)
 *
 * @returns {*[]|*}
 */
export const getSelectedOptions = (providers, modal) => {
  if (providers) {
    const isModalFakeSubscription = checkFakeSubscription(modal);
    if (isModalFakeSubscription) {
      return providers
        .filter((provider) => provider.subscriptions)
        .map((provider) => ({
          label: provider.name,
          value: provider.id,
        }))
    }
    return providers.map((provider) => ({
      label: provider.name,
      value: provider.id,
    }))
  }
  return [];
};
